import { Crown, Sparkles, Star } from "lucide-react";

interface FounderBadgeProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
  animated?: boolean;
}

export function FounderBadge({ 
  className = "", 
  size = 'medium', 
  showLabel = true,
  animated = true 
}: FounderBadgeProps) {
  const sizeClasses = {
    small: "text-xs px-2 py-1",
    medium: "text-sm px-3 py-2", 
    large: "text-base px-4 py-3"
  };

  const iconSizes = {
    small: "w-3 h-3",
    medium: "w-4 h-4", 
    large: "w-5 h-5"
  };

  return (
    <div className={`inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 text-white font-semibold shadow-lg ${sizeClasses[size]} ${animated ? 'animate-pulse hover:animate-none' : ''} ${className}`} data-testid="founder-badge">
      <div className="relative">
        <Crown className={`${iconSizes[size]} text-yellow-200`} />
        {animated && (
          <Sparkles className={`${iconSizes[size]} absolute -top-1 -right-1 text-yellow-300 animate-bounce`} style={{ animationDelay: '0.5s' }} />
        )}
      </div>
      {showLabel && (
        <span className="font-bold tracking-wide" data-testid="founder-badge-label">
          🧸 App Founder
        </span>
      )}
      {animated && (
        <Star className={`${iconSizes[size]} text-yellow-200 animate-spin`} style={{ animationDuration: '3s' }} />
      )}
    </div>
  );
}

// Cute floating badge component for special occasions
export function FloatingFounderBadge() {
  return (
    <div className="fixed top-4 right-4 z-50 pointer-events-none">
      <div className="relative">
        <div className="animate-bounce">
          <FounderBadge size="large" animated={true} />
        </div>
        {/* Cute sparkles around the badge */}
        <div className="absolute -top-2 -left-2 text-pink-400 animate-ping">✨</div>
        <div className="absolute -bottom-2 -right-2 text-purple-400 animate-ping" style={{ animationDelay: '0.5s' }}>💫</div>
        <div className="absolute top-1/2 -left-4 text-blue-400 animate-bounce" style={{ animationDelay: '1s' }}>🌟</div>
      </div>
    </div>
  );
}